// src/config/api.js
export const API = "https://api.orbitmart.co.in/api/v1";
// https://api.orbitmart.co.in/ http://143.244.132.221:4002
// export const API = "https://devapi.orbitmart.co.in/api/v1";
